define('cartware_checkout/classes/loader',[
	"jquery",
	"lodash",
	"gigaset/spinner"
], function(
	$,
	_,
	Spinner
) {
	function Loader() {}

	Loader.prototype = {
		show: function(selectors) {
			Spinner.add(selectors);
		},

		hide: function() {
			Spinner.remove();
		}
	}

	return Loader;
});
